import CheckInMaster from "../pages/CheckInMaster.vue";

import StudyRequirementRecapMeetings from "../pages/StudyRequirementRecapMeetings";

const routes = [
    { path: '/', name: 'CheckInMaster', component: CheckInMaster },
    { path: '/:pathMatch(.*)*', redirect: {name: 'CheckInMaster'}},

    { path: '/a', name: 'StudyRequirementRecapMeetings', component: StudyRequirementRecapMeetings },
];

export default routes;
